import React from "react";
import { Check, FileDown, Loader2, Printer, X } from "lucide-react";

import { CarregandoGrade } from "../../components/carregando";
import CartaoQrMiniatura from "./CartaoQrMiniatura";
import { useQrCodesEmMassa } from "./useQrCodesEmMassa";

// QR Code em massa: todas as mesas numa tela, com o nome de cada uma no meio
// do código. Baixa a imagem de uma mesa, o PDF (4 cartões por folha A4) das
// marcadas, ou manda os cartões para a impressora do caixa.
export default function DialogQrCodesEmMassa({ aberto, onFechar }) {
  const q = useQrCodesEmMassa(aberto);
  if (!aberto) return null;

  const qtd = q.selecionadas.size;
  const rotulo = (texto) => (qtd && !q.todas ? `${texto} (${qtd})` : texto);

  return (
    <div className="fixed inset-0 z-[80] bg-black/60 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4"
         onClick={onFechar} data-e2e="dialog-qr-massa">
      <div className="bg-background rounded-2xl w-full max-w-4xl max-h-[92dvh] border border-border shadow-2xl flex flex-col overflow-hidden"
           onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start gap-3 px-4 sm:px-5 py-4 border-b border-border">
          <div className="min-w-0">
            <h2 className="text-base font-bold">QR Codes das mesas</h2>
            <p className="text-xs text-muted-foreground">
              O nome da mesa vai no meio de cada código. O PDF sai com 4 cartões por folha A4.
            </p>
          </div>
          <button type="button" onClick={onFechar} className="ml-auto p-2 rounded-lg hover:bg-muted">
            <X className="w-4 h-4" />
          </button>
        </div>

        {q.config && !q.config.enabled ? (
          <div className="mx-4 sm:mx-5 mt-3 rounded-xl bg-amber-500/10 border border-amber-500/30 px-3 py-2 text-xs">
            O pedido pela mesa está <strong>desligado</strong>: os códigos abrem uma página avisando.
            Ligue em Configurações, Sistema, Preferências.
          </div>
        ) : null}

        <div className="flex flex-wrap items-center gap-2 px-4 sm:px-5 py-3 border-b border-border">
          <button type="button" onClick={q.alternarTodas} disabled={!q.mesas.length}
                  className="h-9 px-3 rounded-lg border border-border text-xs font-bold flex items-center gap-2 hover:bg-muted">
            <span className={`w-4 h-4 rounded border flex items-center justify-center ${
              q.todas ? "bg-primary border-primary text-primary-foreground" : "border-muted-foreground/40"
            }`}>
              {q.todas ? <Check className="w-3 h-3" /> : null}
            </span>
            {q.carregando ? "Todas" : `Todas (${q.mesas.length})`}
          </button>
          <div className="flex gap-2 ml-auto w-full sm:w-auto">
            <button type="button" onClick={q.baixarPdf} disabled={!qtd || !!q.ocupado}
                    data-e2e="qr-massa-pdf"
                    className="flex-1 sm:flex-none h-9 px-3 rounded-lg border border-border text-xs font-bold flex items-center justify-center gap-1.5 hover:bg-muted disabled:opacity-50">
              {q.ocupado === "pdf" ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileDown className="w-4 h-4" />}
              {rotulo("Baixar PDF")}
            </button>
            <button type="button" onClick={q.imprimir} disabled={!qtd || !!q.ocupado}
                    data-e2e="qr-massa-imprimir"
                    className="flex-1 sm:flex-none h-9 px-3 rounded-lg bg-primary text-primary-foreground text-xs font-bold flex items-center justify-center gap-1.5 disabled:opacity-50">
              {q.ocupado === "imprimir" ? <Loader2 className="w-4 h-4 animate-spin" /> : <Printer className="w-4 h-4" />}
              {rotulo("Imprimir na impressora")}
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-4 sm:p-5">
          {q.carregando ? (
            <CarregandoGrade comImagem quantos={8} className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3" />
          ) : !q.mesas.length ? (
            <p className="py-16 text-center text-sm text-muted-foreground">Nenhuma mesa cadastrada.</p>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
              {q.mesas.map((m) => (
                <CartaoQrMiniatura
                  key={m.id}
                  mesa={m}
                  marcada={q.selecionadas.has(m.id)}
                  onAlternar={() => q.alternar(m.id)}
                  onAtualizarNome={() => q.atualizarNomeQr(m)}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
